import { AuthService } from './../../../../auth/auth.service';
import { environment } from './../../../../environments/environment';
import { Observable, Subscriber } from 'rxjs';
import { AppConfig, AppConfigService } from './../../../../services/app-config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WizardViewModel } from '../dentally/wizard-view-model';
import { TreatmentMapping } from "../dentally/TreatmentMapping";
import { IntegrationData } from "../dentally/IntegrationData";
import { VisitTypeAssignment } from './VisitTypeAssignment';
import { DentallyTreatment } from './DentallyTreatment';
import { VisitTypeGroupped } from './preview/dentally-preview.component';
import { LaunchButtonStatus } from './LaunchButtonStatus';
import { UserProfile } from 'src/models/userprofile';

@Injectable()
export class DentallyWizardService {
  
  private appConfig: AppConfig;
  private orgId = "";
  private userId = "";
  private dentallyWizardPrefix = "dwd";
  private dentallyLaunchButton = "dlb";
  private localStorageId = "";
  private launchButtonStorageid = "";
  private lanchButtonSubscriber:Subscriber<boolean> = null;
  private userProfile: UserProfile;

  constructor(private http: HttpClient, appConfigService: AppConfigService, private authService: AuthService) {
    this.appConfig = appConfigService.getConfig();
    this.removeButtonFromLocalStorage();
    
    this.authService.getClaims$().subscribe((claims:UserProfile)=>{
        this.userProfile = claims;
    });

  }

  getWizardState(): Observable<WizardViewModel> {
    this.initwizardLocalStorage(this.userProfile);
    const wizardState$ = new Observable<WizardViewModel>(subscriber => {
      const localData = localStorage.getItem(this.localStorageId);
      if (localData) {
        const data = JSON.parse(localData) as WizardViewModel;
        subscriber.next(data);
      } else {
        this.getWizardStep()
          .subscribe((r) => {
            if (r) {
              if (!r.data) {
                r.data = new IntegrationData();
              }
              if (!r.data.step) {
                r.data.step = "Introduction";
              }
              this.saveToLocalStorage(r);
            }
            subscriber.next(r);
          });
      }
    });
    return wizardState$;
  }

  activateLaunchButton(): any {
    this.lanchButtonSubscriber.next(true);
    this.saveButtonToLocalStorage({ isEnabled: true });
  }

  updateWizardStep(data: WizardViewModel): Observable<WizardViewModel> {
    var updatedData$ = new Observable<WizardViewModel>(subscriber => {
      this.postWizardStep(data)
        .subscribe(r => {
          const result = r.result;
          this.saveToLocalStorage(result);
          subscriber.next(result);
        },
          error => {
            subscriber.error(error);
          });
    });
    return updatedData$;
  }

  launchIntegration(): Observable<any> {
    const launchIntegration$ = new Observable<any>(subscriber => {
      const url = this.appConfig.oc_api_url +
        environment.oc_api_organizations_url +
        "wizard/start-pulling";
      this.http.post<any>(url, {})
        .subscribe((r) => {
          this.saveButtonToLocalStorage({ isEnabled: false });
          this.lanchButtonSubscriber.next(false);
          subscriber.next(r);
        },
          (err) =>{
            subscriber.error(err)
          }); 
    });
    return launchIntegration$;
  }

  islaunchButtonActive(): Observable<boolean> {
      const buttonStatus$ = new Observable<boolean>(subscriber => {
      const localData = localStorage.getItem(this.launchButtonStorageid);
      this.lanchButtonSubscriber = subscriber;
      if (localData) {
        const data = JSON.parse(localData) as LaunchButtonStatus;
        subscriber.next(data.isEnabled);
      } else {
        this.getLaunchButtonStatus()
          .subscribe((r) => {
            this.saveButtonToLocalStorage(r);
            subscriber.next(r.isEnabled);
          },
            (err) => {
              console.error(err);
              subscriber.next(false);
            });
      }
    });
    return buttonStatus$;
  }
  
  removeFromLocal(): any {
    const allOrgWizards = this.getAllUnfinishedOrganizationWizards();
    allOrgWizards.forEach(w => localStorage.removeItem(w));
  }

  GetTreatments(): Observable<TreatmentMapping[]> {
    const url = this.appConfig.oc_api_url + "api/Organizations/wizard/dentally/visittypemap";
    return this.http.get<any>(url);
  }

  getIntegrationStatus(): Observable<any> {
    const url = `${this.appConfig.oc_api_url}${environment.oc_api_organizations_url}wizard/integration-status`;
    return this.http.get<any>(url);
  }

  groupVisitTypes(assignedVisitTypes: VisitTypeAssignment[], treatments: DentallyTreatment[]): VisitTypeGroupped {
    const grouppedCategories = {} as VisitTypeGroupped;
    assignedVisitTypes.forEach(v => {
      const t = treatments.find(t => t.code === v.itemCodes[0]);
      const treatment = { code: v.itemCodes[0], name: null };
      if (t) treatment["name"] = `${t.code} ${t.patient_description}`;
      if (grouppedCategories[v.visitTypeName]) {
        grouppedCategories[v.visitTypeName].treatments.push(treatment);
      } else {
        grouppedCategories[v.visitTypeName] = { treatments: [], id: v.visitTypeId };
        grouppedCategories[v.visitTypeName].treatments.push(treatment);
      }
    });
    return grouppedCategories;
  }

  removeButtonFromLocalStorage(): any {
    localStorage.removeItem(this.launchButtonStorageid);
  }

  private initwizardLocalStorage(userClaims:UserProfile) {    
    this.orgId = userClaims["organization_id"];
    this.userId = userClaims["sub"];
    this.localStorageId = `${this.dentallyWizardPrefix}-${this.orgId}-${this.userId}`;
  }

  private saveToLocalStorage(result: WizardViewModel) {
    localStorage.setItem(this.localStorageId, JSON.stringify(result));
  }

  private saveButtonToLocalStorage(status: LaunchButtonStatus): any {
    localStorage.setItem(this.launchButtonStorageid, JSON.stringify(status));
  }

  private getLaunchButtonStatus(): Observable<LaunchButtonStatus> {
    const url = this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      "wizard/launch-button-status";
    return this.http.get<LaunchButtonStatus>(url);
  }

  initDentallyButtonLocalStorage() {
    this.orgId = this.userProfile["organization_id"];
    this.launchButtonStorageid = `${this.dentallyLaunchButton}-${this.orgId}`;
  }

  private getAllUnfinishedOrganizationWizards(): string[] {
    const localItems = Object.keys(localStorage);
    const unfinishedWizards = localItems.filter(l => l.startsWith(`${this.dentallyWizardPrefix}-${this.orgId}`));
    return unfinishedWizards;
  }

  private getWizardStep(): Observable<any> {
    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      "wizard";

    return this.http.get<any>(url);
  }

  private postWizardStep(data: WizardViewModel): Observable<any> {
    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      "wizard";

    return this.http.post<any>(url, data);
  }

}
